// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"412":"fad51b30","439":"1f888123"}[chunkId] + ".chunk.css";
};